import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import { devTools } from '@ngneat/elf-devtools';
import { enableElfProdMode } from '@ngneat/elf';

if (environment.production) {
  enableProdMode();
  enableElfProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule, {
    applicationProviders: [provideZoneChangeDetection()],
  })
  .then(() => {
    if (!environment.production) {
      devTools();
    }
  })
  .catch((err) => console.error(err));
